<script>
  import {
    getContext,
    onMount,
    createEventDispatcher,
    tick
  } from "svelte";


  let { product } = getContext("SHOP");

  let dispatcher = createEventDispatcher()

  let stripeElements;
  let cardinfo_errors = [];
  let cardinfo_error_code;

  let loading = false;

  let creditCard;

  export let intent;
  export let isCard = false;
  export let hasShipping = false;
  /** Stripe Elements appearance object; null keeps Stripe's default theme */
  export let appearance = null;
  export let maxWidth = '550px';

  let message = '';

  let paymentElement;

  let paymentDiv;
  let shippingDiv;
  let ready = false;
  let complete = false;

  let stripe = Stripe( process.env.STRIPE_KEY );

  onMount(()=>{
    checkStatus();
    if(intent && !intent.completed){
      init()
    }
  });

  async function init(){

      const options = {
        clientSecret: intent.client_secret,
        ...(appearance && { appearance }),
      };

      stripeElements = stripe.elements(options);

      paymentElement = stripeElements.create("payment",{
        // fields: {
        //   billingDetails: "never"
        // }
      });
      if (hasShipping) {
        const shippingOptions = { mode: 'shipping' };
        const addressElement = stripeElements.create('address', shippingOptions);
        addressElement.mount(shippingDiv);
      }

      await tick();

      paymentElement.mount(paymentDiv);

      paymentElement.on('complete',()=>{
        console.log('complete')
        message = ''
      });

      paymentElement.on('empty',() => {
        console.log('empty');
      });

      paymentElement.on('value',(e) => {
        console.log('value',e);
      });

      paymentElement.on('ready',(e) => {
        ready = true
        dispatcher('ready')
      });

  }

  export function processPayment(){
    handleSubmit()
  }

  async function confirmSetup(){

  }

  async function confirmPayment(){


   return {error,paymentIntent}
  }


  async function handleSubmit(e) {
    if(loading == true) return;
    loading = true
    message = null;

    if(intent.payment_intent.object === 'setup_intent') {
      let { error, setupIntent } = await stripe.confirmSetup({
         elements:stripeElements,
         redirect:"if_required",
         confirmParams: {
           return_url: window.location.href,
         },
       });

       loading = false;

       if (error && (error.type === "card_error" || error.type === "validation_error")) {
         message = error.message;
       } else if(error) {
         message = "An unexpected error occured."
       }

       if(message){
         dispatcher('error')
         return;
       }

       if(setupIntent && setupIntent.status == 'succeeded'){
         completePayment(setupIntent)
       }
    } else {
       let { error, paymentIntent } = await stripe.confirmPayment({
        elements:stripeElements,
        redirect:"if_required",
        confirmParams: {
          return_url: window.location.href,
        },
      });
      loading = false;
      if (error && (error.type === "card_error" || error.type === "validation_error")) {
        message = error.message;
      } else if(error) {
        message = "An unexpected error occured."
      }

      if(message){
        dispatcher('error')
        return;
      }

      if(paymentIntent && paymentIntent.status == 'succeeded'){
        completePayment(paymentIntent)
      }
    }

  }

  async function checkStatus() {
    const clientSecret = new URLSearchParams(window.location.search).get(
      "payment_intent_client_secret"
    );

    if (!clientSecret) {
      dispatcher('error',"Something went wrong")
      return;
    }

    const { paymentIntent } = await stripe.retrievePaymentIntent(clientSecret);

    switch (paymentIntent.status) {
      case "succeeded":
        message = "Payment succeeded!";
        completePayment(paymentIntent)
        break;
      case "processing":
        message = "Your payment is processing"
        break;
      case "requires_payment_method":
        message = "Your payment was not successful, please try again"
        break;
      default:
          message = "Something went wrong"
        break;
    }
  }

  function completePayment(paymentIntent){
    if(paymentIntent && paymentIntent.status == 'succeeded'){
      complete = true
      dispatcher('complete',{subscription:intent.subscription_id,paymentIntent})
    }
  }
</script>

{#if !complete}
  <slot name="header"></slot>
  {#if hasShipping}
    <div id="address-element" style="width:100%;max-width:{maxWidth}; margin: 0 auto;" bind:this={shippingDiv}>
      Loading Payment Details...
    </div>
  {/if}
  <div id="payment-element" style="width:100%;max-width:{maxWidth}; margin: 0 auto;" bind:this={paymentDiv}>
    Loading Payment Details...
  </div>
{/if}
{#if ready && !complete}
    <p class="text-gray-500 text-xs mt-2">By purchasing you are agreeing to our <a class="underline text-blue-600" href="https://oto.coach/terms" target="_blank">terms and conditions</a> and <a class="underline text-blue-600" href="https://oto.coach/privacy" target="_blank">privacy policy</a> and consent to receive marketing and training communications.</p>
                          
    <slot name="button" handlePurchase={processPayment} purchaseLoading={loading}>
      <button type="button" on:click={processPayment} class="mt-3 w-full items-center rounded-md border border-transparent bg-black px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2">{loading? "Please wait.." : isCard ? "Add Card Details" : "Purchase"}</button>
    </slot>
{/if}

{#if message}
   <p class="message error">{message}</p>
{/if}

<style type="text/scss">
  #payment-element,
  #address-element {
    color: #1f2937;
    isolation: isolate;
  }

  .message {
    border-radius: 5px;
    padding: 10px;
    color: black;
    text-align: center;
    &.error {
      background: rgba(255,107,110,.1);
      color: #f32f2f;
      margin-top: 10px;
    }
  }
</style>
